import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="pt-16 relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
          页面未找到
        </h1>
        <p className="text-sm text-foreground-400 font-mono mb-4">{location.pathname}</p>
        <p className="text-base text-foreground-500 mb-6">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex items-center px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-line mr-2"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}